import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DsModalColorVariant, DsModalService, DsModalVariant, DsButtonVariants } from '@levelaccess/design-system';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { IModalDialogInputData } from '../../../../../interfaces/modal-dialog.interface';
import { TranslateService } from '../../../../../translate/translate.service';
import { CustomValidators } from '../../../../../services/helpers/form-custom-validators';
import { ErrorMessageService } from '../../../../../services/error-message.service';

@Component({
  templateUrl: './apikey-delete-confirmation.component.html',
  styleUrls: ['./apikey-delete-confirmation.component.scss'],
  standalone: false,
})
export class ApikeyDeleteConfirmationComponent implements AfterViewInit {
  @Input()
  public modalInputData: IModalDialogInputData<string>;

  @Output()
  public confirmed: EventEmitter<void> = new EventEmitter();

  @ViewChild('modalContent')
  public modalTemplateRef: TemplateRef<any>;
  public modalRef: NgbModalRef;

  public form: UntypedFormGroup;
  public formValidationRequest: Subject<void>;
  public variant: typeof DsModalVariant = DsModalVariant;
  public dsModalColorVariant: typeof DsModalColorVariant = DsModalColorVariant;
  public dsButtonVariants: typeof DsButtonVariants = DsButtonVariants;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private translate: TranslateService,
    private errorMessageService: ErrorMessageService,
    private element: ElementRef<Element>,
    private dsModalService: DsModalService,
  ) {
    this.formValidationRequest = new Subject<void>();
    this.form = this.formBuilder.group({
      confirmation: this.formBuilder.control('', [
        CustomValidators.required,
        CustomValidators.in(new Set([this.translate.instant('delete_apikey_modal_text_to_type')]), true),
      ]),
    });
  }

  public onConfirm(): void {
    this.formValidationRequest.next();
    if (this.form.invalid) {
      this.errorMessageService.setFocusOnFirstError(this.element.nativeElement);
      return;
    }
    this.modalRef.close();
    this.confirmed.emit();
  }

  public ngAfterViewInit(): void {
    this.modalRef = this.dsModalService.open(this.modalTemplateRef, DsModalVariant.center) as NgbModalRef;
  }
}
